import React from 'react';

type SkeletonAnimation = 'pulse' | 'wave' | 'none';

interface SkeletonAssessmentTableProps {
  rows?: number;
  assessmentColumns?: number; // Number of sub-columns under the first grouped header (e.g. DIBELS 8)
  animation?: SkeletonAnimation;
}

export const SkeletonAssessmentTable: React.FC<SkeletonAssessmentTableProps> = ({
  rows = 7,
  assessmentColumns = 7,
  animation = 'wave'
}) => {
  const rowIndexes = Array.from({ length: rows });
  const assessmentColIndexes = Array.from({ length: assessmentColumns });
  const studentColumns = 4;
  const areaOfNeedColumns = 4;
  const totalColumns = studentColumns + assessmentColumns + areaOfNeedColumns;
  // const gridTemplateColumns = `1.6fr 0.8fr 0.8fr ${'0.7fr '.repeat(assessmentColumns).trim()} 1.4fr 0.6fr 0.6fr 1fr`;

  return (
    <div className="skeleton-assessment-table-wrapper">
      <div className="table-container">
        <div className="skeleton-table skeleton-assessment-table skeleton-assessment-table-grid">
          {/* Group header row */}
          <div className="skeleton-assessment-table-row skeleton-assessment-table-group-row" >
            <div className="skeltonFirstCol skeleton-assessment-table-cell skeleton-assessment-table-group-divider" >
              <div className="line skeleton-assessment-table-group-title" />
            </div>
            <div className="gridwidthcol skeleton-assessment-table-cell skeleton-assessment-table-group-divider">
              <div className="line skeleton-assessment-table-group-title" />
            </div>
            <div className="skeltonthirdCol skeleton-assessment-table-cell" >
              <div className="line skeleton-assessment-table-group-title" />
            </div>
          </div>

          {/* Sub-header row */}
          <div className="skeleton-assessment-table-row" >
            <div className="skeltonFirstCol d-flex skeleton-assessment-table-group-divider">
                <div className="skeleton-assessment-table-cell">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="line skeleton-assessment-table-checkbox" />
                    <div className="line ml-1" />
                </div>
                </div>
                <div className="skeleton-assessment-table-cell">
                <div className="line" />
                </div>
                <div className="skeleton-assessment-table-cell" style={{ width: '30%' }}>
                <div className="line" style={{ width: '100%' }}/>
                </div>
            </div>
            <div className='d-flex gridwidthcol skeleton-assessment-table-group-divider'>
                {assessmentColIndexes.map((_, colIndex) => (
                <div style={{ width: '14.5%' }}
                    key={`assessment-header-${colIndex}`}
                    className={`skeleton-assessment-table-cell` }
                >
                    <div className="line" style={{ width: '100%' }}/>
                </div>
                ))}
            </div>
            <div className='d-flex skeltonthirdCol'>
                <div className="skeleton-assessment-table-cell" style={{ width: '33.33%' }}>
                <div className="line" style={{ width: '100%' }}/>
                </div>
                <div className="skeleton-assessment-table-cell" style={{ width: '33.33%' }}>
                <div className="line" style={{ width: '100%' }}/>
                </div>
                <div className="skeleton-assessment-table-cell" style={{ width: '33.33%' }}>
                <div className="line" style={{ width: '100%' }}/>
                </div>
            </div>
          </div>

          {/* Body rows */}
          {rowIndexes.map((_, rowIndex) => (
            <div className="skeleton-assessment-table-row" key={`row-${rowIndex}`}>
                <div className='skeltonFirstCol  d-flex skeleton-assessment-table-group-divider'>
                    <div className="skeleton-assessment-table-cell">
                        <div className="d-flex justify-content-between align-items-center">
                        <div className="line skeleton-assessment-table-checkbox" />
                        <div className="line ml-1" />
                        </div>
                    </div>
                    <div className="skeleton-assessment-table-cell">
                        <div className="line" />
                    </div>
                    <div className="skeleton-assessment-table-cell" style={{ width: '30%' }}>
                        <div className="line" style={{ width: '100%' }} />
                    </div>
                </div>
                <div className='d-flex gridwidthcol '>
                {assessmentColIndexes.map((_, colIndex) => (
                    <div style={{ width: '14.5%' }}
                    key={`assessment-cell-${rowIndex}-${colIndex}`}
                    className={`skeleton-assessment-table-cell ${colIndex === assessmentColumns - 1 ? 'skeleton-assessment-table-group-divider' : ''}`}
                    >
                    <div className="line" style={{ width: '100%' }}/>
                    </div>
                ))}
                </div>
                <div className='d-flex skeltonthirdCol'>
                    <div className="skeleton-assessment-table-cell" style={{ width: '33.33%' }}>
                        <div className="line" style={{ width: '100%' }}/>
                    </div>
                    <div className="skeleton-assessment-table-cell" style={{ width: '33.33%' }}>
                        <div className="line" style={{ width: '100%' }}/>
                    </div>
                    <div className="skeleton-assessment-table-cell" style={{ width: '33.33%' }}>
                        <div className="line" style={{ width: '100%' }}/>
                    </div>
                </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SkeletonAssessmentTable;
